var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5c0 .276.224.501.5.488 5.29-.26 9.5-4.633 9.5-9.988 0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.625 3.14 8.517 7.404 9.66a.478.478 0 0 0 .596-.472V14H9a1 1 0 1 1 0-2h1v-2a3 3 0 0 1 3-3h1a1 1 0 1 1 0 2h-1a1 1 0 0 0-1 1v2h2a1 1 0 1 1 0 2h-2v7.5Z",
    fill: "#777E91"
  })));
};
export default SvgFilled;